import React, { useState, useEffect } from "react";
import {
	useCreateRestaurantPayouts,
	useGetAllRestaurants,
	usegetRestaurantPayoutsBalance,
} from "../../../queryHooks";
import CS from "../../../services/commonService";
import Select from "react-select";

import qs from "qs";
import { useFormik } from "formik";
import { createPayoutsSchema } from "../../../validations/payoutsValidations";
import { useStore } from "../../../zustand/store";

//  Component starts

const CreatePayouts = ({ onCloseModal, refetch }) => {
	const [restaurants, setRestaurants] = useState([]);
	const [restaurantsId, setRestaurantsId] = useState("");
	const [amountValidate, setAmountValidate] = useState("");
	const [restaurantPayload] = useState({
		pagination: false,
		filter: {
			admin_approval_status: "APPROVED",
			child_restaurants: true,
		},
	});
	const setLoading = useStore((state) => state.setLoading);

	const { data: dataGetAllRestaurants } = useGetAllRestaurants(
		qs.stringify(restaurantPayload)
	);

	const { data: dataGetRestaurantPayoutsBalance } =
		usegetRestaurantPayoutsBalance(restaurantsId);

	useEffect(() => {
		if (dataGetAllRestaurants && dataGetAllRestaurants.data?.records) {
			let _restaurants = [];
			dataGetAllRestaurants.data?.records?.forEach((element) => {
				_restaurants.push({
					label: element.name,
					value: element.id,
				});
			});
			setRestaurants(_restaurants);
		}
	}, [dataGetAllRestaurants]);

	const {
		mutateAsync: createStripePayouts,
		error: errorCreateStripePayouts,
		data: dataCreateStripePayouts,
	} = useCreateRestaurantPayouts();

	useEffect(() => {
		if (dataCreateStripePayouts) {
			setLoading(false);
			if (dataCreateStripePayouts.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataCreateStripePayouts.message);
				refetch();
			} else if (dataCreateStripePayouts.status === "fail") {
				CS.showErrorMessage(dataCreateStripePayouts.message);
			}
		}
	}, [dataCreateStripePayouts]);

	useEffect(() => {
		if (errorCreateStripePayouts) {
			setLoading(false);
			CS.showErrorMessage(errorCreateStripePayouts.response?.data?.message);
		}
	}, [errorCreateStripePayouts]);

	const [formData] = useState({
		stripe_amount: "",
	});

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: createPayoutsSchema,
		onSubmit: (value) => {
			if (
				dataGetRestaurantPayoutsBalance?.data?.available?.[0]?.amount <
				parseFloat(value.stripe_amount)
			) {
				setAmountValidate("Amount must be less than available balance");
			} else {
				setAmountValidate("");
				createStripePayouts({
					restaurant_id: restaurantsId,
					amount: value.stripe_amount,
				});
				setLoading(true);
			}
		},
	});

	const handleChangeRestaurants = (restaurant_id) => {
		setRestaurantsId(restaurant_id.value);
	};

	// const selectStyles = {
	// 	control: (provided) => ({ ...provided, minWidth: 240, margin: 8 }),
	// 	menu: () => ({ boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)" }),
	// 	menuPortal: () => ({ zIndex: "1000", width: "240px", position: "absolute", top: "214px", backgroundColor: "white", left: "17px", boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)" })
	//   };

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title">Create Payout for Restaurant </h5>
			</div>
			<div
				className="modal-body"
				style={{
					height: "320px",
					overflow: "auto",
				}}
			>
				<label>Select Restaurant</label>
				<div>
					<Select
						className="default-select"
						searchable={true}
						placeholder="Please select restaurant"
						options={restaurants}
						blurInputOnSelect
						styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
						menuPortalTarget={document.body}
						name="restaurants"
						value={values.label}
						onChange={(value) => {
							handleChangeRestaurants(value);
						}}
					/>
				</div>

				<div className="restaurant-payouts mt-4">
					<p>
						Available balance for this restaurant is {"  "}
						<strong>{` $  ${
							dataGetRestaurantPayoutsBalance?.data?.available?.[0]?.amount || 0
						}`}</strong>
					</p>
				</div>
				<form className="mt-3" onSubmit={(e) => handleSubmit(e)}>
					<div className="form-group mr-2 mb-2">
						<label className="form-label">
							Enter Amount<span className="text-danger">*</span>
						</label>
						<input
							type="number"
							className="form-control"
							id="stripe_amount"
							name="stripe_amount"
							value={values.stripe_amount}
							onChange={handleChange}
							placeholder="Enter amount"
						/>
					</div>
					{dataGetRestaurantPayoutsBalance?.data?.available?.[0]?.amount <
					values.stripe_amount ? (
						<div className="text-danger mt-2 mb-2">{amountValidate}</div>
					) : (
						<div className="error-message-password mt-2 mb-2">
							<span className="text-danger error-msg d-block mb-2">
								{errors.stripe_amount && touched.stripe_amount
									? errors.stripe_amount
									: null}
							</span>
						</div>
					)}
					<button
						type="submit"
						disabled={!restaurantsId ? true : false}
						className="btn btn-primary mb-2 mt-3 float-right mr-2"
					>
						Create
					</button>
				</form>
			</div>
		</div>
	);
};

export default CreatePayouts;
